import { Node } from 'prosemirror-model'
import { EditorView, NodeView } from 'prosemirror-view'
import Styles from './Pill.module.scss'
import { ReactComponent as CloseIcon } from 'assets/icons/close12.svg'
import { createRoot, Root } from 'react-dom/client'

export class Pill implements NodeView {
  dom?: HTMLDivElement
  view: EditorView
  root: Root

  constructor(node: Node, view: EditorView) {
    this.dom = document.createElement('div')
    this.dom.className = Styles.pill
    this.view = view
    const { text } = node.attrs
    this.root = createRoot(this.dom)
    this.render(text)
  }

  private render = (text: string) => {
    if (!this.dom) return null

    this.root.render(
      <>
        <span>{text}</span>
        <button className={Styles.removeTagBtn} onClick={this.destroy}>
          <CloseIcon width={12} height={12} className={Styles.closeIcon} />
        </button>
      </>,
    )
  }

  destroy = () => {
    const oldDom = this.dom
    if (oldDom) {
      this.root.unmount()
      this.dom = undefined
      oldDom.remove()
    }
  }
}
